import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import errorPage from '../assets/error-404.png'
// import './notfound.css'

const NotFound = () => {
 const [name,setName]=useState({name:'',age:''})
  return (
    <div className="not-found">
        <input type='text' onChange={(e)=>{setName(e.target.value)}}/>
        <input type='text' onChange={(e)=>{setName(e.target.value)}}/>

        <div>{name.name}</div> 
        <div>{name.age}</div> 

        <div>
        {/* <img src={errorPage} alt='404'/> */}
             <h2>Page Not Found</h2>
      <button><Link to="/">Go to Home</Link></button>  
     
      </div>

    </div>
  );
};

export default NotFound;
